import { QUERY_KEYS } from "@/libraries/constant";
import { calendarService } from "@/services/calendar";
import { eventService } from "@/services/event";
import { queryOptions } from "@tanstack/react-query";

export const getCalendarsQueryOptions = (
	param: Parameters<typeof calendarService.getCalendars>[0],
) =>
	queryOptions({
		queryKey: [QUERY_KEYS.GET_CALENDARS, param],
		queryFn: ({ signal }) => calendarService.getCalendars(param, { signal }),
		enabled: !!param,
	});

export const getCalendarInfoQueryOptions = (
	param: Record<"start_date" | "end_date", string>,
) =>
	queryOptions({
		queryKey: [QUERY_KEYS.GET_CALENDAR_INFO, param],
		queryFn: ({ signal }) =>
			calendarService.getCalendarInfo({ signal, params: param }),
		enabled: !!param,
	});

export const getCalendarDetailQueryOptions = (
	param: Record<"start_date" | "end_date", string>,
) =>
	queryOptions({
		queryKey: [QUERY_KEYS.GET_CALENDARS_DETAIL, param],
		queryFn: ({ signal }) =>
			calendarService.getCalendarEvents({ signal, params: param }),
		enabled: !!param,
	});

export const getEventQueryOptions = (id: number) =>
	queryOptions({
		queryKey: [QUERY_KEYS.GET_EVENT, id],
		queryFn: ({ signal }) => eventService.getEvent(id, { signal }),
	});
